import _extends from 'babel-runtime/helpers/extends';

import isStringOrStringArray from '@/utils/isStringOrStringArray';

export default {
  name: 'TesterSelector',

  componentName: 'TesterSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    testers: function testers() {
      var _this = this;

      return this.$store.getters.tester.map(function (item) {
        return {
          value: isStringOrStringArray(_this.formValue[_this.innerConfig.prop]) ? String(item.id) : Number(item.id), // 兼容传入参数的类型
          label: item.real_name
        };
      });
    },
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择测试人员'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.testers && !this.testers.length) {
      this.$store.dispatch('GetTester');
    }
  }
};